
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/studio/login",
      function () {
        return require("private-next-pages/studio/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/studio/login"])
      });
    }
  